import { BreakpointsState, orderedBreakpoints } from '../../utils/responsive';

export const getItemsPerPage = (rules: { [k: string]: number }, breakpointsState: BreakpointsState) => {
    const currentKey = orderedBreakpoints.find((key) => breakpointsState[key] && rules[key]);
    return rules[currentKey ? currentKey : 'default'];
};
